// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1mA34","dragIcon":"SortableItem_dragIcon__3NhiC","disabled":"SortableItem_disabled__2FPQu"};